import { IHeartRate } from 'fitbeat.models';
import { Device } from 'react-native-ble-plx';

export const BLUETOOTH_SCAN_TIMEOUT = 180000;

export enum RetryPolicy {
  AlwaysRetry,
  StopAfterRetryCountExceeded,
}

export enum BluetoothState {
  Unknown = 'Unknown',
  Resetting = 'Resetting',
  Unsupported = 'Unsupported',
  Unauthorized = 'Unauthorized',
  PoweredOff = 'PoweredOff',
  PoweredOn = 'PoweredOn',
}

export interface IBluetoothService {
  startListeningForHeartRateDataOn(
    beltNumber: string,
    onHrDataReceived: (data: IHeartRate) => void,
    onHrDataError: (error: string) => void,
    onHrDisconnected: (isExpected: boolean) => void,
    beltScanTimeout?: number,
  ): Promise<void>;
  stopListeningForHeartRateData(): Promise<void>;
  setRetryPolicy(retryPolicy: RetryPolicy);
  onBluetoothStateChange(callback: (state: BluetoothState | any) => void): void;
  askForLocationPermissionIfNotGranted(): Promise<void>;
  verifyIfBluetoothIsActive(): Promise<boolean>;
  isBluetoothPermissionUnauthorized(): Promise<boolean>;
  getDevice(
    onHrDeviceDiscovered: (device: Device) => void,
    onError: (error: Error) => void,
  ): Promise<void>;
  getDeviceDiscoveryTimeout(
    deviceDiscoveryTimeout: number,
    onError: (error: Error) => void);
}
